import { useBreakpointIndex } from '@theme-ui/match-media';
import { FC } from 'react';

import { Button, Link, Paragraph, Spacer, Text } from 'voom-gatsby';

import { ReactComponent as InPersonAppointmentIcon } from '~svg/icons/icon-appointment-in-person.svg';
import { ReactComponent as TelehealthAppointmentIcon } from '~svg/icons/icon-appointment-telehealth.svg';

import { DoctorResult, SanityDoctor, SanityDoctorOffice } from '~types/sanity';

interface AppointmentLinkProps {
  telehealthEmbedCode: string;
  variant: "primary" | "primarySm";
  onClick: (e: any) => void;
}

const AppointmentIcon = ({
  telehealthEmbedCode,
  variant,
  onClick
}: AppointmentLinkProps) => {
  if (telehealthEmbedCode)
    return (<><TelehealthAppointmentIcon
      sx={{
        width: [14, null, null, 17],
        height: [14, null, null, 17],
      }}
    />
      <Spacer direction={'horizontal'} space={2}></Spacer></>
    )

  return (<><InPersonAppointmentIcon
    sx={{
      width: [14, null, null, 17],
      height: [14, null, null, 17],
    }}
  />
    <Spacer direction={'horizontal'} space={2}></Spacer></>
  )
};

export const AppointmentLink: FC<AppointmentLinkProps> = ({
  telehealthEmbedCode,
  variant,
  onClick
}) => {
  const handleAppointmentLinkClick = () => {
    if (window.gtag) {
      window.gtag('event', 'Doctor Appointment Button Clicked', {});
    }
  };

  return (
    <Button
      onClick={onClick}
      variant={variant}
      sx={{
        display: 'flex',
        // flex: 1,
        alignItems: 'center',
        fontSize: ['xs', null, null, 'sm'],
        ':hover': {
          svg: {
            color: 'white',
          },
        },
      }}
    >
      <AppointmentIcon telehealthEmbedCode={telehealthEmbedCode} variant={variant} onClick={onClick}></AppointmentIcon>
      <Text
        sx={{
          fontWeight: 'semibold',
          mr: 2,
          whiteSpace: ['nowrap', null, null, 'normal'],
        }}
      >
        Appointment
      </Text>
    </Button>
  );
};
